import {
    GET_ALERTS,
    GET_ALERTS_SUCCESS,
    GET_ALERTS_FAILURE,
    GET_ALERT_DETAIL,
    GET_ALERT_DETAIL_SUCCESS,
    GET_ALERT_DETAIL_FAILURE,
    ADD_ALERT,
    ADD_ALERT_SUCCESS,
    ADD_ALERT_FAILURE,
    UPDATE_ALERT,
    UPDATE_ALERT_SUCCESS,
    UPDATE_ALERT_FAILURE,
    UPDATE_ALERT_STATUS,
    UPDATE_ALERT_STATUS_SUCCESS,
    UPDATE_ALERT_STATUS_FAILURE,
    ALERT_DETAIL_RESET,
} from '../constants';

export default class AlertManagementAction {
    static GetAlerts(payload) {
        console.log(payload);
        return {
            type: GET_ALERTS,
            payload,
        };
    }

    static GetAlertsSuccess(payload) {
        return {
            type: GET_ALERTS_SUCCESS,
            payload,
        };
    }

    static GetAlertsFailure(isSubscriptionError) {
        return {
            type: GET_ALERTS_FAILURE,
            payload: isSubscriptionError,
        };
    }

    static GetAlertDetail(payload) {
        return {
            type: GET_ALERT_DETAIL,
            payload,
        };
    }

    static GetAlertDetailSuccess(payload) {
        console.log(payload);
        return {
            type: GET_ALERT_DETAIL_SUCCESS,
            payload,
        };
    }

    static GetAlertDetailFailure() {
        return {
            type: GET_ALERT_DETAIL_FAILURE,
        };
    }

    static AddAlert(payload, cb) {
        console.log(payload);
        return {
            type: ADD_ALERT,
            payload,
            cb,
        };
    }

    static AddAlertSuccess() {
        return {
            type: ADD_ALERT_SUCCESS,
        };
    }

    static AddAlertFailure() {
        return {
            type: ADD_ALERT_FAILURE,
        };
    }

    static UpdateAlert(payload, id, cb) {
        return {
            type: UPDATE_ALERT,
            payload,
            id,
            cb,
        };
    }

    static UpdateAlertSuccess() {
        return {
            type: UPDATE_ALERT_SUCCESS,
        };
    }

    static UpdateAlertFailure() {
        return {
            type: UPDATE_ALERT_FAILURE,
        };
    }

    static UpdateAlertStatus(payload, cb) {
        return {
            type: UPDATE_ALERT_STATUS,
            payload,
            cb,
        };
    }

    static UpdateAlertStatusSuccess(payload) {
        return {
            type: UPDATE_ALERT_STATUS_SUCCESS,
            payload,
        };
    }

    static UpdateAlertStatusFailure() {
        return {
            type: UPDATE_ALERT_STATUS_FAILURE,
        };
    }

    static AlertDetailReset() {
        return {
            type: ALERT_DETAIL_RESET,
        };
    }
}
